import { styled as styling } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import Color from "../../../assets/colors";

const scrollbarStyles = {
  "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
    backgroundColor: "transparent",
    width: 4,
    overflow: "auto",
  },
  "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
    borderRadius: 64,
    backgroundColor: Color.hiredlyPurple,
    overflow: "auto",
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: 64,
    backgroundColor: Color.grey,
  },
};

export const useStyles = makeStyles(() => ({
  scrollBar: scrollbarStyles,
}));

export const DescriptionWrapper = styling("div")((props) => ({
  display: "flex",
  gap: "2rem",
  alignItems: "stretch",
  flexDirection: props.$descriptionCount > 2 ? "column" : "row",
  maxHeight: props.$descriptionCount > 2 ? "10rem" : "25rem",
  overflowX: "clip",
  overflowY: props.$descriptionCount > 2 ? "scroll" : "visible",
  paddingRight: props.$descriptionCount > 2 ? "1.5rem" : 0,
  boxSizing: "border-box",
  ...scrollbarStyles,

  "@media (max-width:1279px)": {
    flexDirection: props.$descriptionCount > 2 ? "column" : "row",
    gap: "1.5rem",
    maxHeight: props.$descriptionCount > 2 ? "8.25rem" : "15rem",
    overflowY: props.$descriptionCount > 2 ? "scroll" : "visible",
    paddingRight: props.$descriptionCount > 2 ? "1.25rem" : 0,
  },

  "@media (max-width:640px)": {
    flexDirection: "column",
    gap: "0",
    maxHeight: "37.5rem",
    overflowY: "visible",
    paddingRight: 0,
  },
}));

export const DescriptionContainer = styling("div")((props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  overflowX: "clip",
  overflowY: props.$descriptionCount > 2 ? "visible" : "auto",
  maxHeight:
    props.$descriptionCount > 0
      ? props.$descriptionCount > 2
        ? "fit-content"
        : "25rem"
      : "25rem",
  height: "100%",
  width: props.$descriptionCount > 2 ? "100%" : "auto",
  flex: props.$descriptionCount > 2 ? "unset" : 1,
  minWidth: 0,
  padding: "0 1.5rem 0 0",
  boxSizing: "border-box",
  ...scrollbarStyles,

  "@media (max-width:1279px)": {
    overflowY: props.$descriptionCount > 2 ? "visible" : "auto",
    maxHeight: props.$descriptionCount > 2 ? "fit-content" : "15rem",
    width: props.$descriptionCount > 2 ? "100%" : "auto",
    padding: "0 1.25rem 0 0",
  },

  "@media (max-width:640px)": {
    maxHeight: "16.5rem",
    overflowY: "auto",
    width: "100%",
    flex: "unset",
    padding: "0 1rem 0 0",
  },
}));

export const DescriptionBody = styling("div")({
  letterSpacing: "0.15px",
  color: "rgba(0, 0, 0, 0.75)",
  fontSize: "15px",
  fontFamily: "Inter",
  fontWeight: 400,
  lineHeight: "26.25px",

  "& p": {
    margin: "0 0 14px 0",
  },

  "& p:first-of-type": {
    color: "#000",
    fontStyle: "italic",
  },

  "& p:first-of-type strong": {
    color: "#000",
    fontStyle: "italic",
    fontWeight: 700,
  },

  "& strong": {
    color: "#000",
    fontWeight: 700,
  },

  "& ul": {
    padding: "0 0 0 20px",
    margin: "0 0 14px 0",
  },

  "& li": {
    color: "#000",
    fontSize: "15px",
    fontFamily: "Inter",
    fontWeight: 400,
    lineHeight: "24.75px",
    marginBottom: "12px",
  },

  "& li::marker": {
    color: "#512ACC",
  },

  "@media (max-width:640px)": {
    fontSize: "14px",
    lineHeight: "24px",
  },
});

export const DescriptionCard = styling("div")({
  width: "100%",
  padding: "32px",
  background: "#fff",
  borderRadius: "12px",
  outline: "1px solid #E8E8E8",
  outlineOffset: "-1px",

  "@media (max-width:640px)": {
    padding: "20px 16px",
  },
});

export const DescriptionColumnDivider = styling("div")({
  width: "1px",
  alignSelf: "stretch",
  background: "#E0E0E0",
  flexShrink: 0,

  "@media (max-width:640px)": {
    display: "none",
  },
});
